export const environment = {
    production:true,
    baseUrl:'https://bajajcapitalsec.com'
};
